import { OpeningHoursDayProps } from './OpeningHoursTable';
import styled, { css } from 'styled-components';

const localVariables = {
    defaultLetterSpacing: '0.5px',
};

type OpeningHoursStatusProps = {
    isOpen: boolean;
};

export type OpeningHoursTableTypeProps = {
    type?: 'small';
};

export const OpeningHoursRowStyled = styled.tr<OpeningHoursDayProps>`
    ${({ theme, status }) => css`
        th,
        td {
            border-collapse: collapse;
            color: ${status === 'open'
                ? theme.color.greenLight
                : status === 'closed'
                ? theme.color.red
                : theme.color.primary};
        }
    `}
`;

export const OpeningHoursStatusStyled = styled.span<OpeningHoursStatusProps>`
    ${({ theme, isOpen }) => css`
        display: inline-block;
        margin-bottom: 24px;
        padding: 6px 4px;
        line-height: 8px;

        background-color: ${isOpen ? theme.color.greenLight : theme.color.red};
        color: ${theme.color.white};
        font-size: 12px;
    `}
`;

export const OpeningHoursTableStyled = styled.table<OpeningHoursTableTypeProps>`
    ${({ theme, type }) => css`
        margin-bottom: 16px;

        ${type !== 'small' &&
        css`
            width: 100%;
            margin-top: 30px;
        `}

        overflow-wrap: break-word;
        letter-spacing: ${localVariables.defaultLetterSpacing};

        th,
        td {
            border-collapse: collapse;
            white-space: nowrap;
            line-height: 18px;

            font-size: 13px;
            font-weight: 400;

            @media ${theme.mediaQueries.queryVl} {
                line-height: 24px;
            }

            ${type !== 'small' &&
            `
                line-height: 24px;

                font-size: 15px;

                &:first-child {
                    width: 80px;
                }
            `}
        }

        td {
            display: flex;
            padding-left: 10px;
            flex-wrap: wrap;

            &:first-child {
                padding-left: 0;
            }

            & div {
                margin-right: 10px;
            }
        }

        @media ${theme.mediaQueries.queryVl} {
            th,
            td {
                font-size: ${type === 'small' ? '13px' : '16px'};
            }
        }
    `}
`;

export const OpeningHoursButtonStyled = styled.button`
    ${({ theme }) => css`
        padding: 0;

        background: none;
        border: none;
        outline: none;
        font-size: 13px;
        cursor: pointer;

        svg {
            width: 11px;
            margin-left: 4px;
        }

        span {
            text-decoration: underline;
        }

        &:hover {
            color: ${theme.color.grayDark};
        }
    `}
`;
